import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    id: 'search.noResults.header',
    defaultMessage: 'No results found',
  },
  venueCtaPrompt: {
    id: 'search.noResults.venueCtaPrompt',
    defaultMessage: 'Adjust your location or edit your filters.',
  },
  clearVenueFilters: {
    id: 'search.noResults.clearVenueFilters',
    defaultMessage: 'Clear filters',
  },
  scheduleCtaPrompt: {
    id: 'search.noResults.scheduleCtaPrompt',
    defaultMessage: 'Adjust your location, edit your filters or try a different day.',
  },
  clearScheduleFilters: {
    id: 'search.noResults.clearScheduleFilters',
    defaultMessage: 'Clear filters',
  },
  nextDay: {
    id: 'search.noResults.nextDay',
    defaultMessage: 'Try next day',
  },
  pagination: {
    id: 'search.pagination',
    defaultMessage: 'Page {currentPage}',
  },
  paginationPageCount: {
    id: 'search.paginationPageCount',
    defaultMessage: 'Page {currentPage} of {pageCount}',
  },
  resultTypeBusinesses: {
    id: 'search.result-type.businesses',
    defaultMessage: 'Businesses',
  },
  resultTypeGyms: {
    id: 'search.result-type.gyms',
    defaultMessage: 'Gyms',
  },
  resultTypeStudios: {
    id: 'search.result-type.studios',
    defaultMessage: 'Studios',
  },
  resultTypeClasses: {
    id: 'search.result-type.classes',
    defaultMessage: 'Classes',
  },
  resultTypeSessions: {
    id: 'search.result-type.sessions',
    defaultMessage: 'Sessions',
  },
});
